var _rect, _rect2, _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPickupIconPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 38,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  rx: 19,
  fill: "#F3F9FF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 9.779,
  y: 9.779,
  width: 18.441,
  height: 18.441,
  rx: 2.359,
  fill: "#fff",
  stroke: "#0772E4",
  strokeWidth: 0.559
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.076 19.658a1.098 1.098 0 0 1 0-1.565l3.087-3.046c.404-.398.118-1.078-.453-1.078H21.35a6.973 6.973 0 0 0-4.897 1.999l-2.155 2.125a1.098 1.098 0 0 0 0 1.565l2.205 2.173c1.299 1.28 3.061 2 4.896 2h1.362c.57 0 .856-.68.453-1.079l-3.137-3.094Z",
  fill: "#0772E4"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 27.664,
  cy: 12.016,
  r: 4.75,
  fill: "#0772E4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.663 9.867v4.295-4.295Zm-2.147 2.147h4.294-4.294Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.663 9.867v4.295m-2.147-2.148h4.294",
  stroke: "#fff",
  strokeWidth: 0.838,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgPickupIconPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOCIgaGVpZ2h0PSIzOCIgdmlld0JveD0iMCAwIDM4IDM4IiBmaWxsPSJub25lIj4KICA8cmVjdCB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHJ4PSIxOSIgZmlsbD0iI0YzRjlGRiIvPgogIDxyZWN0IHg9IjkuNzc5NDEiIHk9IjkuNzc5NDEiIHdpZHRoPSIxOC40NDEyIiBoZWlnaHQ9IjE4LjQ0MTIiIHJ4PSIyLjM1OTE3IiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjMDc3MkU0IiBzdHJva2Utd2lkdGg9IjAuNTU4ODI0Ii8+CiAgPHBhdGggZD0iTTIwLjA3NTYgMTkuNjU3N0MxOS42MzgzIDE5LjIyNjMgMTkuNjM4MyAxOC41MjYgMjAuMDc1NiAxOC4wOTI2TDIzLjE2MzMgMTUuMDQ2OEMyMy41NjY3IDE0LjY0OTQgMjMuMjgwNyAxMy45Njg4IDIyLjcxMDIgMTMuOTY4OEgyMS4zNDg3QzE5LjUxMDYgMTMuOTY4OCAxNy43NTEyIDE0LjY4NzQgMTYuNDUxOSAxNS45Njc5TDE0LjI5NjcgMTguMDkyNkMxMy44NTk0IDE4LjUyNCAxMy44NTk0IDE5LjIyNDMgMTQuMjk2NyAxOS42NTc3TDE2LjUwMTYgMjEuODMxM0MxNy44MDA5IDIzLjExMTggMTkuNTYzMSAyMy44MzA0IDIxLjM5ODQgMjMuODMwNEgyMi43NTk5QzIzLjMyOTggMjMuODMwNCAyMy42MTY0IDIzLjE1MDUgMjMuMjEzIDIyLjc1MjRMMjAuMDc2MyAxOS42NTc3SDIwLjA3NTZaIiBmaWxsPSIjMDc3MkU0Ii8+CiAgPGNpcmNsZSBjeD0iMjcuNjY0MSIgY3k9IjEyLjAxNTYiIHI9IjQuNzUiIGZpbGw9IiMwNzcyRTQiLz4KICA8cGF0aCBkPSJNMjcuNjYyOSA5Ljg2NzE5VjE0LjE2MTdWOS44NjcxOVpNMjUuNTE1NiAxMi4wMTQ0SDI5LjgxMDFIMjUuNTE1NloiIGZpbGw9IndoaXRlIi8+CiAgPHBhdGggZD0iTTI3LjY2MjkgOS44NjcxOVYxNC4xNjE3TTI1LjUxNTYgMTIuMDE0NEgyOS44MTAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuODM4MjM1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+";